import { observer } from "mobx-react-lite";
import EditorImageLoader from "./EditorImageLoader";
import ImageChanger from "./ImageChanger";

const ImageControls: ObserverComponent = observer(({ store }) => {
  return (
    <div className="image-controls">
      <EditorImageLoader store={store} />
      <ImageChanger store={store} />
    </div>
  );
});

export default ImageControls;
